import React, { Component } from 'react';
import { connect } from 'react-redux';

import styles from './progressBar.module.scss';

class ProgressBarStyle extends Component {
  render() {
    const { foregroundColor, question } = this.props;
    const questionColor = question && question.color ? `color: ${question.color};` : '';
    return (
      <style type="text/css" scoped>
        {`
          .${styles.progressFront} { background-color: ${foregroundColor}; }
          .${styles.text} { ${questionColor} }
        `}
      </style>
    );
  }
}

const mapStateToProps = (state) => {
  const { customization } = state;
  return {
    foregroundColor: customization.foregroundColor,
    answer: customization.answer,
    question: customization.question,
  };
};

export default connect(mapStateToProps)(ProgressBarStyle);
